import { z } from 'zod';
import { objectIdSchema, paginationQuerySchema } from './common';

export const listNotificationsQuerySchema = paginationQuerySchema;
export type ListNotificationsQuery = z.infer<typeof listNotificationsQuerySchema>;

export const markNotificationsReadSchema = z.object({
  /** Mark everything read when omitted. */
  ids: z.array(objectIdSchema).min(1).max(100).optional(),
});
export type MarkNotificationsReadBody = z.infer<typeof markNotificationsReadSchema>;
